import { Customer } from 'types/CustomerTypes';
import { CustomerServiceInterface } from '../interface/CustomerServiceInterface';

export default class ODMCustomerService implements CustomerServiceInterface {
  async getCustomer(): Promise<Customer> {
    if (!window.ODM || !window.ODM.customer || typeof window.ODM.customer.getCustomer !== 'function') {
      throw new Error('ODM customer service is not available');
    }

    const customerResponse = await window.ODM.customer.getCustomer();

    if (!customerResponse || !customerResponse.data) {
      throw new Error('Failed to fetch customer data from ODM');
    }

    return customerResponse.data;
  }
}
